import React from 'react'

import { Modal } from '@clientbase/clientbase-library'

import { FormCompanyScope } from 'components/CompanySelector'

import { FormNegativationProvider } from './context'
import FormNegativation from './FormNegativation'
import { ModalNegativationProps } from './index.interface'

const ModalNegativation: React.FC<ModalNegativationProps> = ({
  toggleModal,
  modalNegativation,
  invoice
}) => {
  return (
    <Modal
      open={modalNegativation}
      handleClose={() => toggleModal('formNegativation')}
      width="100%"
      maxWidth="85vw"
      maxHeight="90vh"
    >
      {invoice ? (
        // Aberto do detalhe da cobrança: a empresa é a da cobrança
        <FormNegativationProvider>
          <FormNegativation
            handleCloseModal={() => toggleModal('formNegativation')}
            invoice={invoice}
          />
        </FormNegativationProvider>
      ) : (
        // SC-10999: na visão multi-empresas a negativação é feita na empresa
        // escolhida no topo do formulário. Montado só com o modal aberto,
        // porque enquanto montado a empresa vale para as chamadas da página.
        modalNegativation && (
          <FormCompanyScope>
            {(companySelector) => (
              <FormNegativationProvider>
                <FormNegativation
                  handleCloseModal={() => toggleModal('formNegativation')}
                  companySelector={companySelector}
                />
              </FormNegativationProvider>
            )}
          </FormCompanyScope>
        )
      )}
    </Modal>
  )
}

export default ModalNegativation
